import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from "redux";
import {thunk} from "redux-thunk";

import {careerReducer} from "./../redux/careerReducer"
import { jobReducer } from "../redux/jobReducer";



const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({

  careerdata: careerReducer,
  jobdata:jobReducer
});

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
